export const ENUM_REDUCER_STATE_ID = 'enum';
